"use client";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";

export const GenericErrorPage = () => {
  const { trackCustomEvent } = useAnalytics();

  useEffect(() => {
    trackCustomEvent("error_page_view", {
      event_label: "Generic Error",
    });
  }, [trackCustomEvent]);

  return <Box>Something went wrong.</Box>;
};
